// @flow

import React, { Component } from 'react'
import { Link } from 'react-router-dom'

import './BannerImages.css'
import Loading from '../Icons/loading.gif'
import _ from 'lodash'

type Props = {
  data: Array
}

/**
  * Diplay for banner images
  * @class
  * @extends Component
*/
class BannerImages extends Component<Props> {
  /** render function */
  render () {
    const sortedList = _.sortBy(this.props.data, (d) => d.totalViews * -1)
    const list = sortedList.map((banner) => {
      if (banner.title === 'Loading' || banner === 'OFFLINE') {
        return (<table key='Loading'><tbody><tr><td><img src={Loading} alt='Loading' /></td></tr></tbody></table>)
      }
      if (banner.totalViews === 0) {
        return null
      }
      return (
        <div className='BannerDisplay' key={banner._id}>
          <Link to={{ pathname: '/content', search: '?id=' + banner._id + '&date=Week&filter=__' }}>
            <img src={banner.thumbnailUrl} alt='' />
            <p>{banner.title}</p>
          </Link>
          <span><b>{(banner.totalViews || '').toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}</b> Clicks</span>
        </div>
      )
    })
    return (
      <div className='BannerStats box'>
        <h4 className='flex align-center space-between'>
          Top Banner Images
        </h4>
        {list}
      </div>
    )
  }
}

export default BannerImages
